import {
  SET_LIST_EXAMPLE_PICTURE
} from '@/store/mutation-types'
export default {
  [SET_LIST_EXAMPLE_PICTURE] (state, example_pictures) {
    state.example_pictures = example_pictures
  }
}



// WEBPACK FOOTER //
// ./src/components/example-picture/store/mutations.js